/**
 * Configuración de grupos personalizados de permisos
 *
 * Esta configuración es específica para tenant_3pl.
 * Para otros tipos de tenant (ej: tenant_external), crear archivos similares
 * con su propia configuración.
 */

export interface PermissionGroupConfig {
  [groupName: string]: string[];
}

/**
 * Prefijos de slug que no se muestran en crear/editar rol (módulo oculto temporalmente).
 * Ej.: packaging / grupos de cajas (`box_group.view`, `box_group.manage`).
 */
export const PERMISSION_SLUG_PREFIXES_HIDDEN_FROM_ROLES_UI: readonly string[] = ['box_group'];

/**
 * Mapa de agrupación personalizada para tenant_3pl
 * Permite agrupar permisos de diferentes prefijos bajo un mismo grupo
 */
export const TENANT_3PL_GROUP_MAP: PermissionGroupConfig = {
  Billeteras: ['bank-accounts', 'wallets', 'withdrawals', 'topups', 'wallet-transactions'],
  Facturación: ['invoices', 'pre-invoices', 'shipments'],
  Pedidos: ['order-attachments', 'orders', 'shipped-orders'],
  Recepciones: ['receptions'],
  Reportes: ['inventory-report', 'logistics-report', 'product-without-stock-report', 'reports', 'stock-movements'],
  Configuración: ['configuration', 'global', 'iam'],
  'Pago de reembolsos': ['cod-payments'],
};

/**
 * Obtiene el grupo personalizado para un permiso, si existe
 * @param slug El slug del permiso (ej: 'bank-accounts.verify')
 * @param customGroupMap El mapa de grupos personalizados a usar
 * @returns El nombre del grupo personalizado o null
 */
export const getCustomGroup = (slug: string, customGroupMap: PermissionGroupConfig): string | null => {
  const firstDotIndex = slug.indexOf('.');
  if (firstDotIndex === -1) return null;

  const prefix = slug.substring(0, firstDotIndex);

  // Buscar en el mapa de grupos personalizados
  for (const [groupName, prefixes] of Object.entries(customGroupMap)) {
    if (prefixes.includes(prefix)) {
      return groupName;
    }
  }

  return null;
};
